import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../hooks/useAppReducer";
import { useDispatch } from "react-redux";
import { setFlightRoomState } from "../../../features/flightRoom/flightRoomSlice";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import { colors } from "../../../styles/colors";
import { capitalizeFirstLetterEachWords } from "../../../helpers/capitalizeFirstLetterEachWords";
import { roundPriceTransfers } from "../../../helpers/RoundPrice";

interface transferProps {
  handleSubmit?: any;
  saveBasket?: any;
}

export const capitalizeFromDictionary = (() => {
  const dictionary = ["SUV"];
  const regex = new RegExp(`\\b(${dictionary.join("|")})\\b`, "gi");
  return (text: any) =>
    text.replace(regex, (match: any) => match.toUpperCase());
})();

export const CustomHotelTransfter = ({
  saveBasket,
  handleSubmit,
}: transferProps) => {
  const {
    flightRoom,
    flightRoom: { transfer },
  } = useAppSelector((state) => state.flightRoom);
  const { hotelDetails } = useAppSelector((state) => state.hotelDetails);

  let hasShownComplimentaryTransfer = false;
  const cTransfer = "Complimentary Transfer";
  const transferIncluded = "Transfer included as detailed with your chosen accommodation";
  // Calculate total guests
  const totalGuests =
    flightRoom.searchCriteria.adults + flightRoom.searchCriteria.childrens;
  const NONE_OPTION_ID = -1;
  const [selectId, setSelectId] = useState<any>(
    flightRoom?.searchCriteria?.destination?.default_transfer ? 0 : null
  );
  const dispatch = useDispatch();
  const signForPricing = process.env.REACT_APP_CURRENCY_SYMBOL || "";
  const isPlataniumHotel = hotelDetails?.HotelInfo?.HotelInfo?.platinumHotel
    ? Number(hotelDetails.HotelInfo.HotelInfo.platinumHotel) !== 0
    : false;
  const transferData = flightRoom.selectedTransfer;
  useEffect(() => {
    if (flightRoom?.searchCriteria?.destination?.default_transfer) {
      setSelectId(flightRoom?.selectedTransfer?.Transfer?.id);
    } else {
      if (!flightRoom?.selectedTransfer) {
        const complimentaryTransfer = transfer?.pagedata?.find(
          (item: any) => item?.Transfer?.transfer_type === cTransfer
        );
        if (complimentaryTransfer) {
          // Set the ID of the first complimentary transfer
          setSelectId(complimentaryTransfer?.Transfer?.id);
          const payload = dispatch(
            setFlightRoomState({
              ...flightRoom,
              storeMultiRoom: flightRoom.multiRooms,
              storeTransfer: complimentaryTransfer,
              store_psw_result_id: flightRoom.psw_result_id,
              storeSelectedFlights: flightRoom.selectedFlights,
              selectedTransfer: complimentaryTransfer,
              confirmSelection: {
                ...flightRoom.confirmSelection,
                transfer: true,
              },
            })
          ).payload;
          const newData = { ...payload };
          if (newData.hasOwnProperty("roomData")) {
            delete newData["roomData"];
          }
          saveBasket({ updatedFlightRoomState: newData });
        } else {
          //  No complimentary transfer found, fall back to NONE_OPTION_ID
          setSelectId(NONE_OPTION_ID);
        }
      } else {
        setSelectId(transferData?.Transfer.id);
      }
    }
  }, [flightRoom?.selectedTransfer, flightRoom.selectedFlights]);

  // For all destinations, transfers are not required; users can now choose for themselves.
  // For the Maldives, the transfer is selected by default. Users can not choose for themselves.
  const selectedClickButton = (id: any, item: any) => {
    if (flightRoom?.searchCriteria?.destination?.default_transfer) {
      // const payload = dispatch(
      //   setFlightRoomState({
      //     ...flightRoom,
      //     storeMultiRoom: flightRoom.multiRooms,
      //     storeTransfer: item,
      //     store_psw_result_id: flightRoom.psw_result_id,
      //     storeSelectedFlights: flightRoom.selectedFlights,
      //     selectedTransfer: item,
      //     confirmSelection: {
      //       ...flightRoom.confirmSelection,
      //       transfer:
      //         flightRoom.storeTransfer.Transfer.id === item.Transfer.id
      //           ? false
      //           : true,
      //     },
      //   })
      // ).payload;
      // const newData = { ...payload };
      // if (newData.hasOwnProperty("roomData")) {
      //   delete newData["roomData"];
      // }
      // saveBasket({ updatedFlightRoomState: newData });
      // setSelectId(item.Transfer.id);
    } else {
      if (item === null) {
        setSelectId(NONE_OPTION_ID);
        const payload = dispatch(
          setFlightRoomState({
            ...flightRoom,
            storeMultiRoom: flightRoom.multiRooms,
            storeTransfer: null,
            store_psw_result_id: flightRoom.psw_result_id,
            storeSelectedFlights: flightRoom.selectedFlights,
            selectedTransfer: null,
            confirmSelection: {
              ...flightRoom.confirmSelection,
              transfer: false,
            },
          })
        ).payload;
        const newData = { ...payload };
        if (newData.hasOwnProperty("roomData")) {
          delete newData["roomData"];
        }
        saveBasket({ updatedFlightRoomState: newData });
        return;
      } else {
        setSelectId(item.Transfer.id); // set id
        const payload = dispatch(
          setFlightRoomState({
            ...flightRoom,
            storeMultiRoom: flightRoom.multiRooms,
            storeTransfer: item,
            store_psw_result_id: flightRoom.psw_result_id,
            storeSelectedFlights: flightRoom.selectedFlights,
            selectedTransfer: item,
            confirmSelection: {
              ...flightRoom.confirmSelection,
              transfer: true,
            },
          })
        ).payload;
        const newData = { ...payload };
        if (newData.hasOwnProperty("roomData")) {
          delete newData["roomData"];
        }
        saveBasket({ updatedFlightRoomState: newData });
      }
    }
  };

  // useEffect(() => {
  //   if (selectTransfer) {
  //     handleSubmit(flightRoom.selectedTransfer);
  //     setSelectTransfer(false);
  //   }
  // }, [selectTransfer]);

  const renderTransferPrice = (item: any) => {
    const itemSumPrice = item?.Transfer?.cust_tot_sell_amt
      ? parseFloat(item.Transfer.cust_tot_sell_amt)
      : 0;
    const selectedSumPrice = transferData?.Transfer?.cust_tot_sell_amt
      ? parseFloat(transferData.Transfer.cust_tot_sell_amt)
      : itemSumPrice; // fallback to self

    return Math.ceil(itemSumPrice - selectedSumPrice);
  };

  return (
    <Box
      sx={{
        padding: { sm: "20px", xs: "10px" },
        backgroundColor: colors.basics.secondary,
        border: `1px solid ${colors.border.grey}`,
        borderRadius: "4px",
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Typography variant="h2">Select transfers</Typography>
      {transfer?.pagedata?.length > 0 &&
        !flightRoom?.searchCriteria?.destination?.default_transfer &&
        !transfer.pagedata.some(
          (item: any) => item?.Transfer?.transfer_type === cTransfer
        ) && (
          <Box
            onClick={() => selectedClickButton(null, null)}
            padding={2}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "4px",
              border: `1px solid ${selectId === NONE_OPTION_ID
                ? isPlataniumHotel
                  ? colors.basics.plataniumGreenColor
                  : colors.basics.primary
                : "transparent"
                }`,
              backgroundColor: `${selectId === NONE_OPTION_ID
                ? isPlataniumHotel
                  ? colors.basics.plataniumGreenAccentColor
                  : colors.basics.pink
                : "white"
                }`,
            }}
          >
            <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
              <FormControl>
                <FormControlLabel
                  control={
                    <Radio
                      disableRipple
                      checked={selectId === NONE_OPTION_ID}
                      sx={{
                        p: 0,
                        border: "none !important",
                        bgcolor: "transparent !important",
                        color: isPlataniumHotel
                          ? colors.basics.plataniumGreenColor + "!important"
                          : colors.basics.primary,
                      }}
                    />
                  }
                  label=""
                  sx={{ m: 0 }}
                />
              </FormControl>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography>Transfer Not Included</Typography>
              </Box>
            </Box>
          </Box>
        )}

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {/* marginTop: 2 - above */}

        {transfer?.pagedata?.length ? (
          transfer?.pagedata?.map((item: any, i: number) => {
            const isDefaultTransfer =
              flightRoom?.searchCriteria?.destination?.default_transfer;

            const isComplimentary = item?.Transfer?.transfer_type === cTransfer;
            let label;

            if (isDefaultTransfer) {
              label = transferIncluded;
            } else if (isComplimentary) {
              if (!hasShownComplimentaryTransfer) {
                hasShownComplimentaryTransfer = true;
                label = transferIncluded;
              } else {
                return null; // skip rendering duplicate Complimentary Transfer
              }
            } else {
              label = capitalizeFromDictionary(
                capitalizeFirstLetterEachWords(item?.Transfer?.transfer_type)
              );
            }
            return (
              <Box
                onClick={() => {
                  selectedClickButton(i, item);
                }}
                key={i}
                padding={2}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderRadius: "4px",
                  border: `1px solid ${selectId === item.Transfer.id
                    ? isPlataniumHotel
                      ? colors.basics.plataniumGreenColor
                      : colors.basics.primary
                    : "transparent"
                    }`,
                  backgroundColor: `${selectId === item.Transfer.id
                    ? isPlataniumHotel
                      ? colors.basics.plataniumGreenAccentColor
                      : colors.basics.pink
                    : "white"
                    }`,
                }}
              >
                <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
                  <FormControl>
                    <FormControlLabel
                      control={
                        <Radio
                          disableRipple
                          checked={selectId === item.Transfer.id}
                          sx={{
                            p: 0,
                            border: "none !important",
                            bgcolor: "transparent !important",
                            color: isPlataniumHotel
                              ? colors.basics.plataniumGreenColor + "!important"
                              : colors.basics.primary,
                          }}
                        />
                      }
                      label=""
                      sx={{ m: 0 }}
                    />
                  </FormControl>
                  <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                    <Typography key={item.Transfer.id}>{label}</Typography>
                    <Typography
                      variant="subtitle1"
                      fontWeight={700}
                      sx={{ fontSize: { sm: "16px", xs: "12px" }, width: "80px", textAlign: "right" }}
                      data-value={item.Transfer.cust_tot_sell_amt}
                    >
                      {flightRoom?.searchCriteria?.destination?.default_transfer ? (
                        <>
                          {`+${signForPricing}0 pp`}{" "}

                        </>
                      ) : (
                        <>
                          {item?.Transfer?.transfer_type === cTransfer
                            ? null
                            : transferData
                              ? renderTransferPrice(item) >= 0
                                ? `+${signForPricing}${Math.ceil(
                                  roundPriceTransfers(
                                    (parseFloat(
                                      item?.Transfer?.cust_tot_sell_amt ?? 0
                                    ) -
                                      parseFloat(
                                        transferData?.Transfer?.cust_tot_sell_amt ??
                                        0
                                      )) /
                                    totalGuests,
                                    flightRoom.searchCriteria
                                      .isAdditionalTransferAmountAdd,
                                    1,
                                    flightRoom,
                                    item?.Transfer?.exchange_rate || 0
                                  )
                                )} pp`
                                : `-${signForPricing}${Math.ceil(
                                  roundPriceTransfers(
                                    Math.abs(
                                      (parseFloat(
                                        item?.Transfer?.cust_tot_sell_amt ?? 0
                                      ) -
                                        parseFloat(
                                          transferData?.Transfer
                                            ?.cust_tot_sell_amt ?? 0
                                        )) /
                                      totalGuests
                                    ),
                                    flightRoom.searchCriteria
                                      .isAdditionalTransferAmountAdd,
                                    1,
                                    flightRoom,
                                    item?.Transfer?.exchange_rate || 0
                                  )
                                )} pp`
                              : `+${signForPricing}${Math.ceil(
                                roundPriceTransfers(
                                  parseFloat(
                                    item?.Transfer?.cust_tot_sell_amt ?? 0
                                  ) / totalGuests,
                                  flightRoom.searchCriteria
                                    .isAdditionalTransferAmountAdd,
                                  1,
                                  flightRoom,
                                  item?.Transfer?.exchange_rate || 0
                                )
                              )} pp`}
                        </>
                      )}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            );
          })
        ) : (
          <Typography
            variant="h1"
            my={5}
            textAlign="center"
            color={
              isPlataniumHotel
                ? colors.basics.plataniumGreenColor
                : colors.basics.primary
            }
          >
            No Transfer Available
          </Typography>
        )}
      </Box>
    </Box>
  );
};
